import React from "react";
import Footer from "../utils/footer";
import PageSeo from "../components/common/PageSeo";
import { BUSINESS_INFO } from "../constants/businessInfo";

const TermsConditions = () => {
  return (
    <main className="bg-slate-50 pt-28 text-slate-800">
      <PageSeo
        title="Terms and Conditions"
        description="Read the Terms and Conditions of Thakkhar Realtors, including property information disclaimer, pricing disclaimer, and liability limitations."
      />

      <section className="mx-auto max-w-4xl px-6 pb-16">
        <header className="rounded-2xl bg-white p-8 shadow-sm">
          <h1 className="text-3xl font-bold text-slate-900">Terms and Conditions</h1>
          <p className="mt-3 text-sm text-slate-600">Last updated: 18 June 2026</p>
          <p className="mt-4 text-slate-700">
            These terms govern your use of the Thakkhar Realtors website and services.
            By using this website, you agree to these terms.
          </p>
        </header>

        <div className="mt-6 space-y-4">
          <TermCard title="1. Website Usage">
            You agree to use this website lawfully and not misuse content, forms,
            or communication channels.
          </TermCard>

          <TermCard title="2. Property Information Disclaimer">
            Property details are provided for general informational purposes and may
            change based on developer updates, inventory, approvals, and availability.
          </TermCard>

          <TermCard title="3. Pricing Disclaimer">
            Prices, payment plans, and offers displayed on the website are indicative
            and subject to revision without prior notice.
          </TermCard>

          <TermCard title="4. Intellectual Property">
            Website content including text, design, images, and branding is owned by or
            licensed to Thakkhar Realtors and may not be copied or reused without permission.
          </TermCard>

          <TermCard title="5. Limitation of Liability">
            Thakkhar Realtors is not liable for direct or indirect losses resulting from
            reliance on website content, third-party data, or temporary service disruptions.
          </TermCard>

          <TermCard title="6. User Responsibilities">
            You are responsible for providing accurate details while submitting inquiries
            and for independently verifying property and legal documents before final decisions.
          </TermCard>

          <TermCard title="7. Contact Information">
            <p>
              For legal or terms-related queries, contact
              <a
                href={`mailto:${BUSINESS_INFO.businessEmail}`}
                className="ml-1 text-blue-700 hover:underline"
              >
                {BUSINESS_INFO.businessEmail}
              </a>
              or call
              <a
                href={`tel:${BUSINESS_INFO.phone.replace(/\s+/g, "")}`}
                className="ml-1 text-blue-700 hover:underline"
              >
                {BUSINESS_INFO.phone}
              </a>
              .
            </p>
          </TermCard>
        </div>
      </section>

      <Footer />
    </main>
  );
};

const TermCard = ({ title, children }) => (
  <article className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
    <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
    <div className="mt-2 text-sm leading-6 text-slate-700">{children}</div>
  </article>
);

export default TermsConditions;
